import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';
import {
    validateEmail,
    validatePhone,
    validatePostcode
} from '../../../utils/formValidation/validationFunctions';
import { validateFirstName, validateLastName } from '../validation/validationFunctions';

export const validate = (newEntry, type, initialStateOnEntry) => {
    let newErrors = {};

    if (!newEntry.relationshipToParticipant) {
        newErrors = {
            ...newErrors,
            relationshipToParticipant: {
                error: true,
                message: getReqMessage('Relationship to participant')
            }
        };
    }
    newErrors = validateFirstName(newEntry.firstName, newErrors);
    newErrors = validateLastName(newEntry.lastName, newErrors);
    newErrors = validatePhone(newEntry.phoneNumber, newErrors, 'phoneNumber');
    newErrors = validateEmail(newEntry.emailAddress, newErrors);
    newErrors = validatePostcode(newEntry.postcode, newErrors);

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry);

    return newErrors;
};
